var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBubbleTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 23,
    viewBox: "0 0 38 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1879 1.33199C20.0028 0.0688276 17.9972 0.0688257 16.8121 1.33198L1.22368 17.9474C-0.573635 19.8631 0.784691 23 3.41154 23H34.5885C37.2153 23 38.5736 19.8631 36.7763 17.9474L21.1879 1.33199Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubbleTriangle);
export default __webpack_public_path__ + "static/media/message-bubble-triangle.8b56d7f6b2b903b6e3bf096c4beeefa9.svg";
export { ForwardRef as ReactComponent };